import {BannerLayoutComponentModel} from "./banner-layout-component.model";
import {TranslationModel, TranslationService} from "../../services/wrapper/translation.service";
import {Utilities} from "../../utils/utilities";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {
    BannerTranslateEditComponent
} from "../../pages/translation/banner/modal/banner-translate-edit/banner-translate-edit.component";
import {NotificationService} from "../../services/common/notification.service";
import {EventEmitter} from "@angular/core";
import {Constants} from "../../utils/constants";
import {MyStorageService} from "../../services/common/my-storage.service";
import {BannerContentModel} from "./banner-content-layout/banner-content.model";

export abstract class BannerLayoutComponent<T> implements BannerLayoutComponentModel<T> {
    data: T;
    slug: string;
    translations: TranslationModel[];
    language: string;
    emit: EventEmitter<any>;

    protected constructor(protected translationService: TranslationService, protected modalService: BsModalService, protected notificationService: NotificationService, protected myStorageService: MyStorageService) {
    }

    translate(key: string) {
        let tmp = this.getTranslation(key);
        if (tmp != undefined) {
            const localization = tmp.localizations[this.language];
            return localization ? localization.value : "UNKNOWN";
        }
        return "UNKNOWN";
    }

    getTranslation(key: string) {
        return this.translationService.filterByKeyOnArray(key, this.translations);
    }

    edit(key: string) {
        const config = Utilities.createModalConfig({
            text: this[key],
            isSmallText: (key != 'description')
        });
        const bsRef: BsModalRef = this.modalService.show(BannerTranslateEditComponent, config);
        bsRef.content.onCloseWithResponse.subscribe(result => {
            this.update(result, key);
        })
    }

    private update(text: any, key: string) {
        const useTo = this.myStorageService.getFromCookiesWithParse(Constants.USE_TO_ALL_RESTAURANTS, false);
        if (useTo) {
            const restaurants = this.myStorageService.getFromCookiesWithParse(Constants.USER_REST_KEY, []);
            const copy = Object.assign(new BannerContentModel(), this.data);
            restaurants.forEach(restaurant => {
                copy.slug = restaurant.historySlug;
                this.updateProcess(copy, key, text);
            });
        } else {
            this.updateProcess(this.data, key, text);
        }
    }

    private updateProcess(data: any, key: string, text: any) {
        const translation = this.getTranslation(data[key]);
        if (translation) {
            translation.localizations[this.language].value = text;
            this.translationService.update(translation).subscribe(result => {
                this[key] = text;
                this.notificationService.showSuccess("general.success");
            });
        }
    }
}
